







import {Component, Vue} from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import MassImportBody from "@/components/mass-import/MassImportBody.vue";

@Component({
  components: {MassImportBody, GlobalHeader}
})
export default class MassImport extends Vue {
}
